// fill="${color ? color : "currentColor"}"
// width=${width} height=${height}
// currentColor ใส่เเทนสี ที่ต้องการเปลี่ยน สีตาม  ConfigProvider theme
import PropTypes from 'prop-types'

import React from 'react'

const Index = ({ width = 16, height = 16 }) => {
  const svgXml = `
 <svg
      width=${width} height=${height}
      viewBox="0 0 106 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.6033 99.9921C69.237 99.9921 89.2066 96.2608 89.2066 91.6579C89.2066 87.0551 69.237 83.3237 44.6033 83.3237C19.9696 83.3237 0 87.0551 0 91.6579C0 96.2608 19.9696 99.9921 44.6033 99.9921Z"
        fill="#F5F5F7"
        fillOpacity="0.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.2863 67.1734L64.5462 47.8017C63.791 46.8899 62.687 46.3379 61.5245 46.3379H27.6824C26.5206 46.3379 25.4166 46.8899 24.6613 47.8017L8.92188 67.1734V77.2938H80.287V67.1734H80.2863Z"
        fill="#AEB8C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2566 21.3354H66.9493C67.6473 21.3354 68.3166 21.6127 68.8102 22.1062C69.3037 22.5997 69.5809 23.2691 69.5809 23.967V85.3775C69.5809 86.0755 69.3037 86.7448 68.8102 87.2383C68.3166 87.7319 67.6473 88.0091 66.9493 88.0091H22.2566C21.5586 88.0091 20.8893 87.7319 20.3958 87.2383C19.9023 86.7448 19.625 86.0755 19.625 85.3775V23.967C19.625 23.2691 19.9023 22.5997 20.3958 22.1062C20.8893 21.6127 21.5586 21.3354 22.2566 21.3354V21.3354Z"
        fill="#F5F5F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0772 27.8833H61.1278C61.4768 27.8833 61.8115 28.0219 62.0582 28.2687C62.305 28.5154 62.4436 28.8501 62.4436 29.1991V45.6182C62.4436 45.9671 62.305 46.3018 62.0582 46.5486C61.8115 46.7953 61.4768 46.934 61.1278 46.934H28.0772C27.7282 46.934 27.3935 46.7953 27.1468 46.5486C26.9 46.3018 26.7614 45.9671 26.7614 45.6182V29.1991C26.7614 28.8501 26.9 28.5154 27.1468 28.2687C27.3935 28.0219 27.7282 27.8833 28.0772 27.8833ZM28.2495 54.0767H60.9555C61.3501 54.0767 61.7287 54.2335 62.0077 54.5126C62.2868 54.7917 62.4436 55.1702 62.4436 55.5649C62.4436 55.9596 62.2868 56.3381 62.0077 56.6172C61.7287 56.8962 61.3501 57.053 60.9555 57.053H28.2495C27.8548 57.053 27.4763 56.8962 27.1972 56.6172C26.9182 56.3381 26.7614 55.9596 26.7614 55.5649C26.7614 55.1702 26.9182 54.7917 27.1972 54.5126C27.4763 54.2335 27.8548 54.0767 28.2495 54.0767ZM28.2495 61.8155H60.9555C61.3502 61.8155 61.7288 61.9724 62.008 62.2515C62.2871 62.5307 62.4439 62.9093 62.4439 63.304C62.4439 63.6988 62.2871 64.0774 62.008 64.3565C61.7288 64.6357 61.3502 64.7925 60.9555 64.7925H28.2495C27.8548 64.7925 27.4762 64.6357 27.197 64.3565C26.9179 64.0774 26.761 63.6988 26.761 63.304C26.761 62.9093 26.9179 62.5307 27.197 62.2515C27.4762 61.9724 27.8548 61.8155 28.2495 61.8155ZM80.1397 90.4353C79.6298 92.4557 77.839 93.9616 75.7087 93.9616H13.4962C11.366 93.9616 9.57519 92.455 9.06597 90.4353C8.96886 90.0503 8.9198 89.6547 8.91992 89.2576V67.1741H26.2344C28.1469 67.1741 29.6883 68.7846 29.6883 70.7399V70.7662C29.6883 72.7208 31.2476 74.2991 33.1601 74.2991H56.0449C57.9574 74.2991 59.5166 72.7063 59.5166 70.7511V70.7432C59.5166 68.7879 61.0581 67.1734 62.9706 67.1734H80.2851V89.2583C80.2851 89.6642 80.2344 90.0583 80.1397 90.4353Z"
        fill="#DCE0E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.3162 22.4026L77.8227 24.1461C77.7073 24.1909 77.5815 24.2023 77.4599 24.1789C77.3383 24.1555 77.2258 24.0982 77.1352 24.0137C77.0447 23.9292 76.9799 23.8208 76.9483 23.7011C76.9166 23.5813 76.9194 23.4551 76.9563 23.3368L78.2306 19.2533C76.5273 17.3164 75.5273 14.9546 75.5273 12.4059C75.5273 5.83026 82.1839 0.5 90.3958 0.5C98.6056 0.5 105.263 5.83026 105.263 12.4059C105.263 18.9816 98.6063 24.3118 90.3951 24.3118C87.4162 24.3118 84.6425 23.6105 82.3162 22.4026Z"
        fill="#DCE0E6"
      />
      <path
        d="M96.2513 14.556C97.2865 14.556 98.1256 13.7268 98.1256 12.704C98.1256 11.6812 97.2865 10.8521 96.2513 10.8521C95.2161 10.8521 94.377 11.6812 94.377 12.704C94.377 13.7268 95.2161 14.556 96.2513 14.556Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.4127 14.3243H82.6641L84.5706 11.0835L86.4127 14.3243ZM88.7555 11.0835H92.0351V14.3243H88.7555V11.0835Z"
        fill="white"
      />
    </svg>
   `

  return (
    <div
      style={{ display: 'flex', alignItems: 'center' }}
      dangerouslySetInnerHTML={{ __html: svgXml }}
    />
  )
}
Index.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}
export default Index
